export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/cn.9269fa3e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};